import { Platform } from 'react-native';

// Import images for web (Vite handles these as URLs)
import kawaImg from '@/assets/gifts/kawa.png';
import prezentImg from '@/assets/gifts/prezent.png';
import czekoladaImg from '@/assets/gifts/czekolada.png';
import wycieczkaImg from '@/assets/gifts/wycieczka.png';
import kwiatyImg from '@/assets/gifts/kwiaty.png';
import misImg from '@/assets/gifts/mis.png';

export type Gift = {
  id: string;
  name: string;
  price: number;
  image: any;
  type: 'digital' | 'physical';
};

// Helper to get image source compatible with both platforms
const getImageSource = (webImage: string, nativeRequire: number | { uri: string }) => {
  if (Platform.OS === 'web') {
    return { uri: webImage };
  }
  return nativeRequire;
};

export const GIFTS: Gift[] = [
  { id: '1', name: 'Kawa', price: 5, image: getImageSource(kawaImg, kawaImg as any), type: 'digital' },
  { id: '2', name: 'Róża', price: 5, image: getImageSource(prezentImg, prezentImg as any), type: 'digital' },
  { id: '3', name: 'Czekolada', price: 5, image: getImageSource(czekoladaImg, czekoladaImg as any), type: 'digital' },
  { id: '4', name: 'Fajerwerki', price: 5, image: getImageSource(prezentImg, prezentImg as any), type: 'digital' },
  { id: '5', name: 'Globus', price: 1505, image: getImageSource(wycieczkaImg, wycieczkaImg as any), type: 'physical' },
  { id: '6', name: 'Kwiaty', price: 155, image: getImageSource(kwiatyImg, kwiatyImg as any), type: 'physical' },
  { id: '7', name: 'Miś', price: 200, image: getImageSource(misImg, misImg as any), type: 'physical' },
];

